export const HEADER_SEARCH_OPEN = 'search.open';

export const REGISTRATION_OPEN = 'wh.common.command.ui.registration.flow.start';

export const SESSION_STATE_CHANGED = 'wh.common.event.session.state.changed';
export const SESSION_STATE_GET_COMMAND = 'wh.common.command.session.state.get';
export const SESSION_STATE_GET_EVENT = 'wh.common.event.session.state.get';

export const SESSION_TOKEN_GET_COMMAND = 'wh.common.command.session.token.get';
export const SESSION_TOKEN_GET_EVENT = 'wh.common.event.session.token.get';
export const GOT_LOGIN_STATE_EVENT = 'gotLoginState';
export const REQUEST_GOT_LOGIN_STATE_EVENT = 'requestGotLoginState';
export const ACCOUNT_LOGIN_SUCCESS_EVENT = 'account.login.success';
export const SESSION_SYNCHRONIZED_EVENT = 'wh.sports.event.session.synchronized';
export const SESSION_SYNCHRONIZATION_ERROR = 'wh.sports.event.session.error';
export const OB_SESSION_STATE_CHANGED = 'wh.common.event.obsession.state.changed';
export const NATIVE_LOGIN = 'native.login';

export const ACCOUNT_ACTION_REQUESTED = 'wh.common.event.account.action.requested';
export const DEPOSIT_MODAL_OPENED = 'wh.common.event.ui.header.deposit.opened';
export const FEEDBACK_OPEN_TOPIC = 'feedback.open';
export const ODDS_FORMAT_CHANGE_TOPIC = 'onOddsFormatChanged';
export const ODDS_FORMAT_CHANGE_TOPIC_NEW = 'wh.sports.event.oddsformat.changed';

export const SIDEBAR_NAVIGATION_OPEN = 'sidebarNavigation.open';
export const SIDEBAR_NAVIGATION_CLOSE = 'sidebarNavigation.close';

export const WH_RADIO_PLAY_REQUESTED = 'mediaplayers.whradio.play';
export const WH_RADIO_PAUSE_REQUESTED = 'mediaplayers.whradio.stop';
export const WH_RADIO_MUTE_REQUESTED = 'mediaplayers.whradio.mute';
export const WH_RADIO_UNMUTE_REQUESTED = 'mediaplayers.whradio.unmute';

export const RADIO_STATE_UPDATED = 'wh.sports.event.radio.state.updated';
export const RADIO_MUTE_TOGGLE = 'wh.sports.event.radio.mute.toggle';
export const RADIO_PLAY_CLICKED = 'wh.sports.event.radio.play.clicked';
export const RADIO_PAUSE_CLICKED = 'wh.sports.event.radio.pause.clicked';
export const RADIO_MARQUEE_ANIMATION_START = 'wh.sports.event.radio.marquee-animation.start';

export const LANGUAGE_ITEM_CLICKED = 'wh.sports.event.ui.header.language-item.clicked';
export const LANGUAGE_SELECT = 'wh.common.event.ui.header.language.selected';
export const LANGUAGE_SELECT_COMMAND = 'wh.sports.command.ui.header.language.select';

export const SUB_NAV_MENU_EVENT_TOPIC = 'wh.common.event.ui.header.sub-menu-end.requested';

export const MY_ACCOUNT_OPEN_REWARDS_TOPIC = 'wh.myAccount.event.navigationMenu.select.rewards';
export const MY_ACCOUNT_OPEN_HELP = 'wh.myAccount.event.footer.request.help';
export const MY_ACCOUNT_OPEN_FEEDBACK = 'wh.myAccount.event.footer.request.feedback';
